module.exports = __webpack_public_path__ + "img/bizpro-logo.e91a430b.svg";